<template>
  <fts-modal-standard
    title="Create a module"
    description="It can be a process or a workflow like ticketing, approval, or leave application. Or, it can be a collection of entries like employees, products or customers"
    :disable-close="submitting"
    @closed="reset"
    ref="ftsModuleCreateDefaultModal"
  >
    <template #body>
      <div class="module-create-emoji">
        <fts-emoji
          :width="576"
          placement="bottom"
          v-model="formData.emoji"
        >
          <div
            slot-scope="{ emoji, disabled, isDefault }"
            class="module-create-emoji-toggle"
            :class="[
              { 'module-create-emoji-toggle--default': isDefault },
              { 'module-create-emoji-toggle--disabled': disabled }
            ]"
          >        
            <fts-moji :size="48" :emoji="emoji"/>
          </div>
        </fts-emoji>
      </div>

      <fts-form-element
        :item="{
          fieldName: 'name',
          displayName: 'Module Name',
        }"
        :form-data="formData"
        :validator="$v.formData"
        :validator-error="moduleNameError"
        comfort-design
        @input="getModuleEmoji"
      />
    </template>
    <template #footerRight>
      <fts-btn
        color="primary"
        text-transform-init
        box-shadow-none
        :loading="submitting"
        @click="done"
      >
        Create
      </fts-btn>
    </template>
  </fts-modal-standard>
</template>

<script>
import Vue from 'vue';
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);

import designValidator from '../commons/designValidator';
import { store as canvasDesignStore } from '../store/canvasDesignStore';

import FTSBtn from '../elements/FTSBtn';
import FTSEmoji from '../elements/FTSEmoji';
import FTSFormElement from '../elements/FTSFormElement';
import FTSModalStandard from '../elements/FTSModalStandard';
import FTSMoji from '../elements/FTSMoji';

export default {
  components: {
    'fts-btn': FTSBtn,
    'fts-emoji': FTSEmoji,
    'fts-form-element': FTSFormElement,
    'fts-modal-standard': FTSModalStandard,
    'fts-moji': FTSMoji
  },
  validations() {
    let formData = {};
    if (!this.submitting) {
      formData = designValidator.moduleDesign(this.modules);
    }
    return { formData };
  },
  data: () => ({
    showDialog: false,
    formData: {},
    resolve: null,
    beforeResolve: null,
    submitting: false
  }),
  methods: {
    async show(payload) {
      return new Promise(async (resolve) => {
        if (payload.beforeResolve) {
          this.beforeResolve = payload.beforeResolve
        }
        this.resolve = resolve;
        this.$refs.ftsModuleCreateDefaultModal.show();
        try {
          await canvasDesignStore.dispatch("loadWorkspace", {
            id: payload && payload.workspaceId
          });
        } catch(err) {
          console.error(err);
        }
      });
    },
    close() {
      this.$refs.ftsModuleCreateDefaultModal.close();
    },
    reset() {
      this.$v.$reset();
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    async done() {
      this.$v.formData.$touch();
      if (!this.$v.formData.$invalid) {
        try {
          this.submitting = true;
          await canvasDesignStore.dispatch("addVector", {
            ...this.formData
          });
          if (typeof this.beforeResolve === 'function') {
            await this.beforeResolve();
          }
          this.resolve && this.resolve(this.moduleId);
          this.close();
        } catch(err) {
          console.error(err);
          this.$toasted.global.error({
            response: err.response,
            message: 'Failed to create module'
          });
        } finally {
          this.submitting = false;
        }
      }
    },
    moduleNameError() {
      return designValidator.moduleDesignError(this.$v.formData, "name");
    },
    getModuleEmoji: _.debounce(async function() {
      if (this.formData.name) {
        const res = await canvasDesignStore.dispatch("ai", {
          type: "emoji",
          text: this.formData.name
        });
        if (res.data) {
          this.$set(this.formData, "emoji", res.data);
        }
      }
    }, 800)
  },
  computed: {
    modules() {
      return canvasDesignStore.getters.workspaceModules;
    },
    moduleId() {
      return canvasDesignStore.state.vectorId;
    }
  }
}
</script>

<style lang="scss">
.module-create-emoji {
  display: flex;
  justify-content: center;
  .module-create-emoji-toggle {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
    cursor: pointer;
    &.module-create-emoji-toggle--default {
      border-radius: 10em;
      outline: 2px dashed var(--fts-border);
      outline-offset: 0.5rem;
      filter: grayscale(1);
      opacity: 0.5;
      &:hover {
        filter: grayscale(0);
        opacity: 1;
      }
    }
    &.module-create-emoji-toggle--disabled {
      cursor: not-allowed;
    }
  }
}
</style>